const Discover360Page = () => import('./Discover360Page.vue');

const routes = [
  {
    path: '/discover360',
    name: 'discover360',
    component: Discover360Page,
    meta: {
      title: 'DISCOVER360 – Se découvrir, guérir, se repositionner et réussir',
      description:
        'Formation complète de 6 semaines pour une transformation intégrale : identité, guérison émotionnelle, repositionnement et réussite professionnelle & financière',
      requiresAuth: false
    }
  }
];

export default routes;
